<template>
    <PlanbordGridContainer v-if="roster" :informationColumns="informationColumns" :dayColumns="dayColumns" :hourBalanceColumns="hourBalanceColumns" :compact="compact">
        <!-- Include preparedness -->
        <WorkloadRequirementsHead :roster="roster" />
        <LegacyWorkloadRequirementsBody
            :negativeOnly="viewOptions.showOnlyNegativeValues"
            :roster="roster"
            :sorting="sorting"
            :organisationDeploymentStates="organisationDeploymentStates"
            :shifts="shifts"
            :resourceFunctionNames="resourceFunctionNames"
        />
    </PlanbordGridContainer>
</template>

<script lang="ts">
    import LegacyWorkloadRequirementsBody from '@/components/Planbord/WorkloadRequirements/LegacyWorkloadRequirementsBody.vue';
    import WorkloadRequirementsHead from '@/components/Planbord/WorkloadRequirements/WorkloadRequirementsHead.vue';
    import {RosterData, ViewOptions, PermissionsForRoster} from '@/types/types';
    import {WorkloadRequirementSorting} from '@/types/enums/WorkloadRequirementSorting';
    import {OrganisationDeploymentState, Shift} from '@cquential/api';
    import PlanbordGridContainer from '@/components/Planbord/PlanbordGridContainer.vue';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component({
        components: {
            LegacyWorkloadRequirementsBody,
            WorkloadRequirementsHead,
            PlanbordGridContainer,
        },
    })
    export default class LegacyWorkloadTable extends Vue {
        @Prop({required: true}) public roster!: RosterData;
        @Prop({default: WorkloadRequirementSorting.Alphabet}) public sorting!: WorkloadRequirementSorting;
        @Prop({required: true}) public organisationDeploymentStates!: Record<number, OrganisationDeploymentState>;
        @Prop({required: true}) public shifts!: Record<number, Shift>;
        @Prop({required: true}) public viewOptions!: ViewOptions;
        @Prop({required: true}) public permissions!: PermissionsForRoster;
        @Prop({required: true}) public resourceFunctionNames!: Record<number, string>;
        @Prop({type: Number, required: true}) public informationColumns!: number;
        @Prop({type: Number, required: true}) public dayColumns!: number;
        @Prop({type: Number, required: true}) public hourBalanceColumns!: number;
        @Prop({type: Boolean}) public compact!: boolean;
    }
</script>
